export default "dist/images/297df8c0e47764ea113951318b2acf55.png";